import { useMemo } from "react";
import useMitreCategories from "security-app/components/SecurityEvents/Alerts/MitreCategories/useMitreCategories";
const toLabel = (name, id) => `${id} ${name}`;
const useMitreFlatOptions = () => {
  const { data, isInitialLoading } = useMitreCategories();
  const options = useMemo(() => {
    var _a;
    const seen = /* @__PURE__ */ new Set();
    const out = [];
    const push = (id, name, depth, ancestors) => {
      const value = id.toLocaleUpperCase();
      if (seen.has(value)) return;
      seen.add(value);
      out.push({ value, label: toLabel(name, value), name, depth, breadcrumb: [...ancestors, name].join(" \u203A ") });
    };
    ((_a = data == null ? void 0 : data.tactics) != null ? _a : []).forEach((tactic) => {
      var _a2;
      push(tactic.id, tactic.name, 0, []);
      ((_a2 = tactic.techniques) != null ? _a2 : []).forEach((technique) => {
        var _a3;
        push(technique.id, technique.name, 1, [tactic.name]);
        ((_a3 = technique.subtechniques) != null ? _a3 : []).forEach((subtechnique) => {
          push(subtechnique.id, subtechnique.name, 2, [tactic.name, technique.name]);
        });
      });
    });
    return out;
  }, [data == null ? void 0 : data.tactics]);
  return { options, isLoadingOptions: isInitialLoading };
};
export default useMitreFlatOptions;
